<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :custom-on-row-click="goto"
      :entity-name="$t('product')"
      :model="model"
      :use-add-action="false"
      :use-edit-action="false"
      icon="mdi-food-fork-drink"
    >
      <template
        #item.dishName="{item}"
      >
        <div
          style="max-width: 210px;"
        >
          {{ item.dishName }}
        </div>
      </template>
      <template
        #footer="{selectItems}"
      >
        <v-btn
          color="primary"
          elevation="0"
          @click="newAdd"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t('newProduct') }}
        </v-btn>
        <template v-if="false">
          <v-dialog
            v-model="showUploadDishDialog"
            max-width="60%"
            persistent
          >
            <template #activator="{on, attrs}">
              <v-btn
                v-bind="attrs"
                class="ml-2"
                elevation="0"
                outlined
                style="background: white"
                v-on="on"
              >
                <v-icon left>
                  mdi-import
                </v-icon>
                {{ $t('bulkImport') }}
              </v-btn>
            </template>
            <v-card>
              <upload-dish-page
                @close="closeDialog"
                @successImport="closeDialog"
              />
            </v-card>
          </v-dialog>
        </template>

        <v-dialog
          v-model="helpDialog"
          max-width="400px"
        >
          <v-card>
            <v-card-title>{{ $t('useInfo') }}</v-card-title>
            <v-card-text>
              <div class="text-h4">
                {{ $t('welcomeUseItems') }}👏
              </div>
              <div class="text-body-1 mt-4">
                <p>
                  {{ $t('productHint1') }}
                </p>
                <p>
                  {{ $t('productHint2') }}
                </p>
                <p>
                  {{ $t('productHint3') }}
                </p>
                <p>
                  {{ $t('productHint4') }}
                </p>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pb-4">
              <v-btn
                color="primary"
                elevation="0"
                @click="read"
              >
                {{ $t('iUnderStand') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          class="ml-2"
          outlined
          style="background: white"
          @click="helpDialog=true"
        >
          <v-icon
            class="mt-1"
            left
          >
            mdi-information-outline
          </v-icon>
          {{ $t('help') }}
        </v-btn>
      </template>
    </ik-data-table>

    <show-new-add-dialog
      v-model="showNewAddDialog"
      :new-product-code="editItemCode"
      @close="closeNewAddDialog"
    />
  </div>
</template>

<script>

  import Dish from '../../../../model/dish/Dish'
  import { IkDataTable } from 'metaflow-js'
  import UploadDishPage from '@/views/AadenPages/dishes/dish-display/UploadDishPage'
  import ShowNewAddDialog from '@/views/AadenPages/dishes/dish/ShowNewAddDialog'
  import { Remember } from '@/GlobalSettings'

  export default {
    name: 'DishesManagePage',
    components: {
      ShowNewAddDialog,
      UploadDishPage,
      IkDataTable,
    },
    data: function () {
      return {
        editItemCode: '',
        keyCode: '',
        newDishCode: null,
        showNewAddDialog: null,
        showUploadDishDialog: false,
        model: Dish,
        helpDialog: null,
      }
    },
    watch: {
      showNewAddDialog (val) {
        if (!val) {
          this.keyCode = ''
          this.editItemCode = ''
        }
      },
    },
    async mounted () {
      window.onkeydown = async (event) => {
        if (event.keyCode !== 13) {
          this.keyCode += event.key
        } else {
          const res = (await Dish.getList(true)).filter(it => it.code === this.keyCode)
          if (res.length !== 0) {
            this.goto(res[0])
          } else {
            this.showNewAddDialog = true
            this.editItemCode = this.keyCode
          }
        }
      }
      if (!Remember.readItemHint) {
        this.helpDialog = true
      }
    },
    activated () {
      this.reload()
    },
    methods: {
      read () {
        Remember.readItemHint = true
        this.helpDialog = false
      },
      async reload () {
        if (!this.$refs.table.loading) {
          this.$refs.table.reload()
        }
      },
      closeNewAddDialog (newDishCode) {
        this.showNewAddDialog = false
        this.$refs.table.reload()
        this.$refs.table.search = newDishCode
      },
      newAdd () {
        this.showNewAddDialog = true
      },
      goto (item) {
        this.$router.push({
          name: 'dishDetail',
          params: {
            id: item.dishId,
          },
        })
      },

      closeDialog () {
        this.showUploadDishDialog = false
      },
    },
  }
</script>
